var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 105,
    viewBox: "0 0 102 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_77_2644)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.33203,
    y: 0.834961,
    width: 93.3333,
    height: 93.3333,
    rx: 26.6667,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.9987,
    y: 1.50163,
    width: 92,
    height: 92,
    rx: 26,
    stroke: "#D9D9D9",
    strokeWidth: 1.33333,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.102 1.75757C17.5419 1.75619 15.0201 2.37888 12.7549 3.57173C10.0859 4.98416 7.87212 7.12439 6.37033 9.74413C6.09562 10.2557 5.83664 10.7756 5.59376 11.3031C5.45522 11.6655 5.30064 12.0213 5.17814 12.3677C4.92801 13.0865 4.73754 13.8247 4.60866 14.5749C4.41887 15.5476 4.32629 16.5369 4.33231 17.528V77.491C4.32489 79.8575 4.85836 82.1944 5.89199 84.3233C7.18047 86.9973 9.19769 89.2532 11.7115 90.8314C14.2254 92.4097 17.1338 93.2462 20.102 93.2447H52.1212C52.233 93.2448 52.3438 93.2228 52.4472 93.18C52.5506 93.1373 52.6445 93.0745 52.7236 92.9954C52.8027 92.9163 52.8654 92.8224 52.9082 92.719C52.951 92.6156 52.9729 92.5049 52.9728 92.393V88.5678C52.9729 88.4559 52.951 88.3451 52.9082 88.2417C52.8654 88.1384 52.8027 88.0444 52.7236 87.9653C52.6445 87.8862 52.5506 87.8235 52.4472 87.7807C52.3438 87.738 52.233 87.716 52.1212 87.7161H47.9671L35.564 62.5985L63.8593 25.0989C64.1052 24.7691 64.2855 24.395 64.3901 23.9972L90.3186 27.9675V33.819C90.3199 34.0437 90.41 34.2587 90.5693 34.4172C90.7286 34.5756 90.9441 34.6647 91.1688 34.6649H95.0166C95.2408 34.6632 95.4554 34.5736 95.6143 34.4155C95.7733 34.2574 95.8639 34.0432 95.8668 33.819V17.5287C95.8685 15.1804 95.3431 12.8616 94.3293 10.7434C93.3156 8.6251 91.8393 6.7614 90.0094 5.28965C87.2073 3.00371 83.7017 1.75574 80.0854 1.75684H20.1027L20.102 1.75757ZM20.102 7.28027H31.6535L32.4774 13.958L17.1649 11.6174L12.3349 10.8721C13.2906 9.74477 14.4806 8.83936 15.822 8.21902C17.1635 7.59867 18.6241 7.27831 20.102 7.28027ZM57.3777 7.28027L58.7194 17.964L37.7559 14.771L36.8087 7.32257L57.3777 7.28027ZM62.5016 7.28027H79.236C82.1706 7.28778 84.983 8.4566 87.0586 10.5313C89.1341 12.6061 90.3041 15.418 90.3127 18.3527V22.7948L63.9388 18.7617L62.5016 7.28027ZM12.6229 16.0799L31.7708 19.0184L21.0813 33.224L12.6229 16.0799ZM37.4861 19.8898L58.9068 23.1681L33.0425 57.4805L23.5991 38.3253L37.4861 19.9226V19.8898ZM9.87106 22.0503L16.7238 35.9256L9.87106 36.767V22.0503ZM79.7296 39.9703C69.5249 39.9703 60.3629 41.4016 60.3629 51.8994V53.8981C60.3629 59.1444 62.1786 64.6781 69.5256 67.5408L83.0706 72.723C87.4602 74.5262 88.605 76.3404 88.605 79.1076V80.2524C88.605 84.3547 86.2163 85.2158 78.5863 85.2158H60.9382C60.7437 85.1872 60.5451 85.2045 60.3584 85.2664C60.1717 85.3282 60.002 85.4328 59.863 85.5719C59.7239 85.711 59.6193 85.8806 59.5575 86.0673C59.4956 86.254 59.4783 86.4526 59.5069 86.6471V90.845C59.5069 91.6062 59.7942 92.1801 60.9382 92.2705C62.5606 92.4623 70.0937 93.1324 78.3945 93.1324C91.2803 93.1324 97.6656 91.0469 97.6656 80.3632V79.2993C97.6656 74.0537 96.9044 69.1843 88.1252 65.8484L75.4363 60.7902C70.7645 59.0715 69.5256 56.7725 69.5256 54.1117V52.8721C69.5256 49.4349 72.1003 47.9138 76.4899 47.9138H94.2335C94.4278 47.9413 94.6258 47.9232 94.8119 47.861C94.998 47.7988 95.1672 47.6943 95.306 47.5555C95.4448 47.4168 95.5494 47.2477 95.6117 47.0616C95.674 46.8755 95.6922 46.6775 95.6648 46.4832V42.3802C95.6807 42.1916 95.6585 42.0018 95.5995 41.8221C95.5405 41.6423 95.4459 41.4762 95.3214 41.3337C95.1969 41.1913 95.045 41.0753 94.8748 40.9928C94.7045 40.9102 94.5194 40.8628 94.3304 40.8533C89.4859 40.2631 84.6099 39.9682 79.7296 39.9703ZM19.1023 40.7578L28.6792 60.1193L9.87106 62.4855V41.923L19.1023 40.7578ZM31.0417 64.9712L42.2665 87.7161H20.9529C18.0167 87.7092 15.2026 86.5402 13.1258 84.4645C11.049 82.3889 9.87826 79.5756 9.8696 76.6393V67.6312L31.0417 64.9712Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_77_2644",
    x: 0.332031,
    y: 0.834961,
    width: 101.332,
    height: 103.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_2644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_2644",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4);
export default __webpack_public_path__ + "static/media/c4.6f97df793db25e732a350b15f6d62b11.svg";
export { ForwardRef as ReactComponent };